module.exports = __webpack_public_path__ + "static/media/Seadra_gaussian2.78166328.png";